<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import { onMounted } from "vue"

onMounted(() => {
  $("#compareSchoolsAdmissions").dataTable({
    bPaginate: false,
    bInfo: false,
    order: [[5, "asc"]],
    aoColumnDefs: [
      { sType: "html", aTargets: [0] },
      { sType: "title-numeric", aTargets: [5] },
      { sType: "title-numeric", aTargets: [6] },
      { asSorting: ["asc", "desc"], aTargets: [0] },
      { asSorting: ["desc", "asc"], aTargets: ["_all"] },
    ],
    oLanguage: {
      sSearch: "Filter schools:",
    },
  })
})
</script>
